import { render, staticRenderFns } from "./importer.vue?vue&type=template&id=253a9b7a&scoped=true&"
import script from "./importer.vue?vue&type=script&lang=js&"
export * from "./importer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a9b7a",
  null
  
)

export default component.exports